import {makeAutoObservable} from 'mobx';
import {api} from '../api/api';
import {ISearchResultItem} from '../types/types';
import {IRootStore} from "./RootStore";

export interface ISearchStore {
    // Идет запрос.
    isLoading: boolean;
    // По запросу ничего не найдено.
    isNotFound: boolean;
    list: ISearchResultItem[];
    rootStore: IRootStore;
    getItems: (query: string) => void;
    clearList: () => void;
}

class SearchStore implements ISearchStore {
    isLoading = false;
    isNotFound = false;
    list: ISearchResultItem[] = [];
    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this);
    }

    getItems = (query: string) => {
        this.isLoading = true;
        this.isNotFound = false;
        api.getSearchResults(query)
            .then(this.handleRequestFulfilled, this.handleRequestRejected)
    };

    handleRequestFulfilled = (list: ISearchResultItem[]) => {
        this.list = list;
        this.isLoading = false;
        this.isNotFound = !list.length;
    };

    handleRequestRejected = () => {
        this.isLoading = false;
    };

    clearList = () => {
        this.list = [];
        if (this.isLoading) {
            api.cancelSearch();
            this.isLoading = false;
        }
    };
}

export default SearchStore;
